// extracted by mini-css-extract-plugin
module.exports = {"wishlistButton":"wishlist_wishlistButton__bcuCb","animation":"wishlist_animation__OD55k"};